import React, { useEffect, useState } from 'react';
import { batch, useDispatch } from 'react-redux';
import {
	useNavigate,
	useParams,
	useSearchParams,
} from 'react-router-dom';

import { GetGreenroomToken, GetPresenterAllowed } from '../../connection/auth';
import {
	SET_SELECTED_APP,
	SIGN_IN_PRESENTER,
} from '../../stores/actions/session';
import { handleClickJacking } from '../../utils/utils';
import RedirectSplash from './redirect-splash';
import logger from '../../utils/logger-rum';

export default function OAuth() {
	const [hasFailure, setHasFailure] = useState<boolean>(false);

	const dispatch = useDispatch();
	const navigate = useNavigate();

	// From the route: `/oauth/:roomId`
	const { roomId: meetingHash } = useParams();
	const [searchParams] = useSearchParams();
	const platformToken = searchParams.get('code');

	let page = meetingHash ? `/${meetingHash}` : '/';

	useEffect(() => {
		handleClickJacking();
	}, []);

	useEffect(() => {
		const loginWithToken = async () => {
			if (!platformToken) return;

			const grTokenResponse = await GetGreenroomToken(platformToken);

			if (grTokenResponse) {
				const {
					token: greenroomToken,
					app_signed_in_with: appSignedInWith,
				} = grTokenResponse;

				batch(() => {
					dispatch({
						type: SET_SELECTED_APP,
						payload: appSignedInWith,
					});

					dispatch({
						type: SIGN_IN_PRESENTER,
						promise: new Promise((resolve) => {
							resolve({
								token: greenroomToken,
								app_signed_in_with: appSignedInWith,
							});
						}),
					});
				});

				if (meetingHash) {
					// presenterAllowed.allowed: Platform's user allowed decision.
					const presenterAllowed = await GetPresenterAllowed(
						grTokenResponse.token,
						meetingHash,
					);

					// In the unlikely event that we didn't hear back from the API,
					// send the user back to the home page.
					if (!presenterAllowed) {
						page = '/';

						return;
					}

					if (!presenterAllowed.allowed) {
						window.location.href = presenterAllowed.auth_required;
					}
				}
			} else {
				setHasFailure(true);
			}
		};

		loginWithToken()
			.then(() => navigate(page))
			// eslint-disable-next-line no-console
			.catch((error) => logger.error(error));
	}, [meetingHash, platformToken]);

	return (
		<RedirectSplash hasFailure={hasFailure} />
	);
}
